import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyAnnouncement = loadable(() => import(/* webpackChunkName: "content/guest/announcement" */ './Announcement'));
